/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lesson_Field_DurationInputs */

const en_lesson_field_duration = /** @type {(inputs: Lesson_Field_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duration`)
};

const he_lesson_field_duration = /** @type {(inputs: Lesson_Field_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`משך`)
};

/**
* | output |
* | --- |
* | "Duration" |
*
* @param {Lesson_Field_DurationInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const lesson_field_duration = /** @type {((inputs?: Lesson_Field_DurationInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lesson_Field_DurationInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lesson_field_duration(inputs)
	return he_lesson_field_duration(inputs)
});